import {
  WEEK_DAYS,
  generateTimeOptions,
  formatTime,
  getSlotList,
  getTimeSlotClass as getTimeSlotClassBase,
  getTimeSlotsClass as getTimeSlotsClassBase,
  getRandomInt,
} from "../utils/tarifSharedUtils";

// Re-export shared utilities
export {
  WEEK_DAYS,
  generateTimeOptions,
  formatTime,
  getSlotList,
  getRandomInt,
};

export const periodColors = [
  "#0075a3",
  "#ffd100",
  "#42b4e6",
  "#BB2649",
  "#6667AB",
  "#0F4C81",
  "#88B04B",
  "#009B77",
  "#DD4124",
  "#D65076",
  "#45B8AC",
  "#363945",
  "#9A8B4F",
  "#0072B5",
  "#A0DAA9",
  "#1E1E1E",
  "#B9B9A8",
  "#F5DF4D",
];

export const getTimeSlotClass = (currentTimeSlot, slotList) => {
  return getTimeSlotClassBase(currentTimeSlot, slotList, periodColors);
};

export const getUsedWeekdays = (selectedSeason, activeDayGroup) => {
  const usedWeekdays = new Set();
  selectedSeason?.periods?.forEach((dayGroup, index) => {
    if (index !== activeDayGroup) {
      (dayGroup.weekDays || []).forEach((day) => usedWeekdays.add(day));
    }
  });
  return usedWeekdays;
};

export const getTimeSlotsClass = (currentTimeSlot, slotList) => {
  return getTimeSlotsClassBase(currentTimeSlot, slotList, periodColors);
};
